import { IStore } from '@cian/top3-reviews-widget';

export const reviewsReducer = (state: IStore | null) => state || null;
